import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { all_routes } from "../../Router/all_routes";
import { useForm } from "react-hook-form"; // Import useForm from react-hook-form

import { GetRequest, PatchRequest } from "../../Api/ApiFunctions";
import { ApiUrl, ConfUrl } from "../../Api/EndPoints";
import {
  ConfImageUploadService,
  flattenObject,
  ImageDataModalRequired,
  transformObject,
} from "./constants";
import MultipleImage from "./Components/MultipleImage";

const Footer = () => {
  const route = all_routes;
  const [AccreditationLogo, setAccreditationLogo] = useState([]);

  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { isSubmitting },
  } = useForm(); // Set up useForm

  const fetchData = async () => {
    const res = await GetRequest(`${ApiUrl.configuration}${ConfUrl.footer}`);
    if (res) {
      setAccreditationLogo(res?.value?.accreditationLogo);
      const val = flattenObject(res?.value, "");
      Object.keys(val).forEach((key) => {
        setValue(key, val[key]);
      });
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const onSubmit = async (data) => {
    let Req = transformObject(data);

    Req.accreditationLogo = await Promise.all(
      AccreditationLogo.map(async (it) => {
        let imgKey = null;
        if (it.image instanceof File) {
          imgKey = await ConfImageUploadService(it.image);
        }
        return {
          key: it.key,
          image: imgKey ? imgKey : it.image,
        };
      })
    );

    const resp = await PatchRequest(
      `${ApiUrl.configuration}${ConfUrl.footer}`,
      Req
    );
    if (resp) {
      navigate(route.jobapplication);
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Site Footer</h4>
              {/* <h6>Create new Career</h6> */}
            </div>
          </div>
        </div>
        {/* /add */}
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="card">
            <div className="card-body add-product pb-0">
              <div className="row">
                <h4>
                  <u>Accreditation Logo</u>
                </h4>
                <div className="col-12">
                  <MultipleImage
                    id="accreditationLogo"
                    dataSource={AccreditationLogo}
                    setDataSource={setAccreditationLogo}
                    DataRequired={[ImageDataModalRequired.image]}
                    DataLimit={3}
                  />
                </div>
                <div className=" col-12">
                  <div className="mb-3 add-product">
                    <label className="form-label">Description</label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("cmpny_Description", {
                        required: "description is required",
                      })}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-sm-6 col-12">
                  <div className="mb-3 add-product">
                    <label className="form-label">Company Name</label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("cmpny_Name", {
                        required: "location is required",
                      })}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-sm-6 col-12">
                  <div className="mb-3 add-product">
                    <label className="form-label">Street</label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("cmpny_Street", {
                        required: "location is required",
                      })}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-sm-6 col-12">
                  <div className="mb-3 add-product">
                    <label className="form-label">City</label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("cmpny_City", {
                        required: "location is required",
                      })}
                    />
                  </div>
                </div>

                <div className="col-lg-6 col-sm-6 col-12">
                  <div className="mb-3 add-product">
                    <label className="form-label">Country</label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("cmpny_Country", {
                        required: "location is required",
                      })}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-sm-6 col-12">
                  <div className="mb-3 add-product">
                    <label className="form-label">Tel</label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("cmpny_Tel", {
                        required: "location is required",
                      })}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-sm-6 col-12">
                  <div className="mb-3 add-product">
                    <label className="form-label">Fax</label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("cmpny_Fax", {
                        required: "location is required",
                      })}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-sm-6 col-12">
                  <div className="mb-3 add-product">
                    <label className="form-label">Mail</label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("cmpny_Mail", {
                        required: "location is required",
                      })}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-sm-6 col-12">
                  <div className="mb-3 add-product">
                    <label className="form-label">Linkedin Url</label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("cmpny_Linkedin", {
                        required: "location is required",
                      })}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-sm-6 col-12">
                  <div className="mb-3 add-product">
                    <label className="form-label">Copyright</label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("cmpny_Copyright", {
                        required: "location is required",
                      })}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="btn-addproduct mb-4">
              <button type="button" className="btn btn-cancel me-2">
                Cancel
              </button>

              <button
                type="submit"
                className="btn btn-submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <span className="spinner-border spinner-border-sm"></span>
                ) : (
                  "Save"
                )}
              </button>
            </div>
          </div>
        </form>
        {/* /add */}
      </div>
    </div>
  );
};

export default Footer;
